module.exports = __webpack_public_path__ + "img/20.2d44b24f.svg";